import { Button } from "../../ui-components/Button";
import { Flex } from "../../ui-components/Flex";
import { NewTextLogo } from "../../ui-components/Logo";
import "./SignUpHeader.scss";
import { useLocation, useNavigate } from "react-router-dom";

export const SignUpHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Flex justify="between" className="topBar-margin xs-col-justify">
      <NewTextLogo fill="#215383" />
      {location.pathname !== "/auth/sign-up" && (
        <Button fill primary={true} className="w-40" onClick={() => navigate("/")}>
          Browse Bonds
        </Button>
      )}
    </Flex>
  );
};
